import { EDeliverableType, EPlatformFeature } from '@enums/campaign.enum';

export enum EAdvancedSettings {
  sponsoredContentRelevant = 'sponsoredContentRelevant',
}

export interface IAdvancedSettingRule {
  defaultValue: boolean | number | string;
  excludedDeliverableTypes?: EDeliverableType[];
  platformFeatures: EPlatformFeature[];
}
